<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :md="2" :lg="2" :span="2">
            <el-select size="medium" placeholder="状态" style="width: 90%;" v-model="searchStatusSelect" clearable>
              <el-option label="待受理" value="0" key="0"></el-option>
              <el-option label="已取消" value="1" key="1"></el-option>
              <el-option label="已受理" value="2" key="2"></el-option>
              <el-option label="已完成" value="3" key="3"></el-option>
            </el-select>
          </el-col>
          <el-col :md="3" :lg="3" :span="3">
            <el-select size="medium" placeholder="是否贷款" style="width: 93%" v-model="searchLoanSelect" clearable>
              <el-option label="全部" value="-1" key="-1" />
              <el-option label="是" value="1" key="1"></el-option>
              <el-option label="否" value="0" key="0"></el-option>
            </el-select>
          </el-col>
          <el-col :md="2" :lg="2" :span="2">
            <el-select style="width: 90%;" placeholder="渠道" v-model="searchChannelSelect" @focus="getAllChannel"
              clearable size="medium">
              <el-option label="全部" value="-1" key="-1" />
              <el-option v-for="channel in channels" :value="channel.channelId" :key="channel.channelId"
                :label="channel.channelName"></el-option>
            </el-select>
          </el-col>
          <el-col :md="6" :lg="6" :span="6">
            <el-date-picker v-model="createTime" style="width: 97%" align="center" type="daterange" size="medium"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :md="3" :lg="4" :span="5">
            <el-input size="medium" placeholder="姓名、手机、品牌、车型、业务员" v-model="key" clearable
              style="width: 95%;"></el-input>
          </el-col>
          <el-col :md="2" :lg="2" :span="2">
            <el-button size="medium" type="primary" @click="searchGuideBooking" icon="el-icon-search">搜索</el-button>
          </el-col>
          <el-col :md="2" :lg="2" :span="2">
            <el-button @click="exportGuideBooking" type="success" size="medium"
              v-if="checkButtonPermission('guidebooking:manage:export')">导出</el-button>
          </el-col>
          <el-col :md="4" :lg="3" :span="2">
            &nbsp;
            <el-button size="medium" type="success" @click="openDialog('add', null)"
              v-if="checkButtonPermission('guidebooking:manage:add')">新增导购</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border fixed min-height="400" style="width: 100%">
          <el-table-column label="序号" align="center" width="70">
            <template slot-scope="scope"><span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }} </span></template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="70" />
          <el-table-column prop="telephone" label="电话" min-width="120" />
          <el-table-column prop="salesmanId" label="业务员" min-width="70">
            <template slot-scope="scope" v-if="null != scope.row.userInfo">
              <span v-html="scope.row.userInfo.userName"></span>
            </template>
          </el-table-column>
          <el-table-column prop="salesmanId" label="业务员电话" min-width="90">
            <template slot-scope="scope" v-if="null != scope.row.userInfo">
              <span v-text="scope.row.userInfo.telephone"></span>
            </template>
          </el-table-column>
          <el-table-column prop="channel.channelName" label="渠道" min-width="120" />
          <el-table-column prop="carBrand.carBrandName" label="品牌" min-width="120" />
          <el-table-column prop="carType.carCategoryName" label="车型" min-width="70" />
          <el-table-column prop="whetherLoan" label="是否贷款" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.whetherLoan == 0">否</span>
              <span v-if="scope.row.whetherLoan == 1">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间" min-width="140"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待受理</span>
              <span v-if="scope.row.status == 1">已取消</span>
              <span v-if="scope.row.status == 2">已受理</span>
              <span v-if="scope.row.status == 3">已完成</span>
            </template>
          </el-table-column>

          <el-table-column prop="remark" label="备注信息" width="80">
            <template slot-scope="scope" v-if="undefined != scope.row.remark && '' != scope.row.remark">
              <el-tooltip class="item span_hover" effect="light" :content="scope.row.remark" placement="top">
                <span class="span_hide remark" v-html="scope.row.remark" />
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column prop="orderType" label="订单类型" min-width="70" />
          <el-table-column prop="orderTitle" label="标题" min-width="70" />

          <el-table-column label="操作" min-width="220" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openDialog('edit', scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('guidebooking:manage:edit')">编辑
              </el-button>
              <el-button @click="openDialog('info', scope.row)" type="info"
                style="background-color: #7266ba; border-color: #7266ba;" size="mini"
                v-if="checkButtonPermission('guidebooking:manage:detail')">详情</el-button>
              <el-button @click="deleteGuideBooking(scope.row.guideBookingId)" type="danger" size="mini"
                v-if="checkButtonPermission('guidebooking:manage:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="addGuideBookingDialogTitle + '预约订单'" :visible.sync="addGuideBookingDialogVisible" :modal="false"
      :close-on-click-modal="false" @closed="resetForm('guideBookingForm')" @open="openDialogEvent(addFlag)">
      <el-form :model="guideBookingForm" ref="guideBookingForm" :rules="guideBookingRules" label-width="120px"
        size="medium" style="padding: 0 10%;">
        <el-form-item label="姓名" prop="name">
          <el-input v-if="addFlag != 'info'" v-model="guideBookingForm.name" clearable></el-input>
          <span v-else-if="addFlag == 'info'" v-text="guideBookingForm.name"></span>
        </el-form-item>
        <el-form-item label="电话" prop="telephone">
          <el-input v-if="addFlag != 'info'" v-model="guideBookingForm.telephone" clearable></el-input>
          <span v-else-if="addFlag == 'info'" v-text="guideBookingForm.telephone"></span>
        </el-form-item>
        <el-form-item label="业务员" prop="salesmanId">
          <!--          <el-input v-model="guideBookingForm.salesmanId" clearable></el-input>-->
          <span v-if="null != guideBookingForm.salesmanId" v-html="guideBookingForm.userInfo.realName"></span>
        </el-form-item>
        <el-form-item label="渠道" prop="channelId">
          <el-select v-if="addFlag != 'info'" placeholder="渠道" v-model="editDialogChannelSelect"
            @change="editDialogChannelChange" clearable size="medium">
            <el-option v-for="channel in editDialogChannels" :value="channel.channelId" :key="channel.channelId"
              :label="channel.channelName"></el-option>
          </el-select>
          <span v-else-if="addFlag == 'info'" v-text="editDialogChannelSelect"></span>
        </el-form-item>
        <el-form-item label="品牌" prop="brandId">
          <el-select v-if="addFlag != 'info'" placeholder="品牌" v-model="editDialogCarBrandSelect" clearable
            @change="editDialogCarBrandChange" size="medium">
            <el-option v-for="brand in editDialogCarBrands" :value="brand.carBrandId" :key="brand.carBrandId"
              :label="brand.carBrandName"></el-option>
          </el-select>
          <span v-else-if="addFlag == 'info'" v-text="editDialogCarBrandSelect"></span>
        </el-form-item>
        <el-form-item label="车型" prop="carCategory">
          <el-select v-if="addFlag != 'info'" placeholder="车型" v-model="editDialogCarCategorySelect" clearable
            @change="editDialogCarCategoryChange" size="medium">
            <el-option v-for="category in editDialogCarCategory" :value="category.carCategoryId"
              :key="category.carCategoryId" :label="category.carCategoryName"></el-option>
          </el-select>
          <span v-else-if="addFlag == 'info'" v-text="editDialogCarCategorySelect"></span>
        </el-form-item>
        <el-form-item label="是否贷款" prop="whetherLoan">
          <el-select v-model="whetherLoanSelect" v-if="addFlag != 'info'">
            <el-option v-for="wetherLoan in wetherLoans" :label="wetherLoan.label" :value="wetherLoan.value"
              :key="wetherLoan.value">
            </el-option>
          </el-select>
          <span v-else-if="addFlag == 'info' && whetherLoanSelect == 1" v-text="'是'"></span>
          <span v-else-if="addFlag == 'info' && whetherLoanSelect == 0" v-text="'否'"></span>
        </el-form-item>
        <el-form-item v-if="!addFlag" label="时间" prop="createTime">
          <span clearable> {{ guideBookingForm.createTime }} </span>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-if="addFlag != 'info'" clearable v-model="guideBookingForm.remark" type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" />
          <span v-else-if="addFlag == 'info'" v-text="guideBookingForm.remark"></span>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <!--<el-input v-model="guideBookingForm.status" clearable></el-input>-->
          <el-select v-model="statusSelect" @change="statusSelectChange" v-if="addFlag != 'info'">
            <el-option v-for="status in statusSelectOptions" :label="status.label" :value="status.value"
              :key="status.value">
            </el-option>
          </el-select>
          <span v-else-if="addFlag == 'info'" v-text="statusSelect"></span>
        </el-form-item>
        <el-form-item size="large">
          <el-button
            @click="addGuideBookingDialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitGuideBookingForm('guideBookingForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--<el-dialog :visible.sync="uploadDialogVisible">
      <img width="100%" :src="userForm.carCategoryImage" alt="">
    </el-dialog>-->
  </div>
</template>

<script>
export default {
  name: "guideBookingList",
  data() {
    return {
      key: '',
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      addGuideBookingDialogTitle: '新增',
      addGuideBookingDialogVisible: false,
      addFlag: true,
      guideBookingForm: {},
      guideBookingRules: {},
      guideBookingId: '',
      createTime: [],
      whetherLoanSelect: 0,
      statusSelect: '',
      statusSelectOptions: [
        {
          label: '待受理',
          value: '0',
        },
        {
          label: '已取消',
          value: '1',
        },
        {
          label: '已受理',
          value: '2',
        },
        {
          label: '已完成',
          value: '3',
        },
      ],
      wetherLoans: [
        {
          label: '是',
          value: 1
        },
        {
          label: '否',
          value: 0
        },
      ],
      searchStatusSelect: '',
      searchLoanSelect: '',
      searchChannelSelect: '',
      channels: [],
      dialogStatusVal: 0,
      editDialogChannels: [],
      editDialogCarBrands: [],
      editDialogCarCategory: [],
      editDialogChannelSelect: '',
      editDialogChannelSelectVal: '',
      editDialogCarBrandSelect: '',
      editDialogCarBrandSelectVal: '',
      editDialogCarCategorySelect: '',
      editDialogCarCategorySelectVal: '',
      orderType: '',
      orderTitle: '',
    }
  },
  created() {
    this.searchGuideBooking();
  },
  methods: {
    editDialogCarCategoryChange(val) {
      this.editDialogCarCategorySelectVal = val;
    },
    editDialogCarBrandChange(val) {
      this.editDialogCarBrandSelectVal = val;
      this.editDialogCarCategorySelect = "";
      this.editDialogGetCarCategory(val);
    },
    editDialogChannelChange(val) {
      this.editDialogChannelSelectVal = val;
    },
    exportGuideBooking() {
      let guideBookingIds = [];
      this.tableData.forEach(guideBooking => {
        guideBookingIds.push(guideBooking.guideBookingId);
      });

      this.$http({
        url: '/api/advance-order-service/guidebooking/export',
        method: 'post',
        responseType: 'blob',
        data: guideBookingIds,
      }).then(res => {
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '导购单.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(e => {

      })
    },
    editDialogGetChannel() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "success") {
          this.editDialogChannels = data.resultList;
        }
      }).catch(e => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + e, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    editDialogGetCarBrand() {
      this.$http.post('/api/car/brand/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "success") {
          this.editDialogCarBrands = data.resultList;
        }
      }).catch(e => {

      })
    },
    editDialogGetCarCategory(carBrandId) {
      this.$http.post('/api/car/category/label?carBrandId=' + carBrandId).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "0") {
          this.editDialogCarCategory = data.data;
        }
      }).catch(e => {

      })
    },
    getAllChannel() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "success") {
          this.channels = data.resultList;
        }
      }).catch(e => {

      })
    },
    searchGuideBooking() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        key: this.key,
        startCreateTime: this.createTime[0],
        endCreateTime: this.createTime[1],
      };

      if ('' != this.searchLoanSelect && -1 != this.searchLoanSelect) {
        reqParam.whetherLoan = this.searchLoanSelect;
      }

      if ('' != this.searchStatusSelect - 1 != this.searchStatusSelect) {
        reqParam.status = this.searchStatusSelect;
      }

      if (-1 != this.searchChannelSelect) {
        reqParam.channelId = this.searchChannelSelect;
      }

      this.$http.post('/api/advance-order-service/logged/guidebooking/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let pageInfo = resp.data.pageInfo;
        this.tableData = pageInfo.list;
        this.pageSize = pageInfo.pageSize;
        this.total = pageInfo.total;
        this.totalPage = pageInfo.pages;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    openGuideBookingAddDialog() {
    },
    addGuideBooking(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/advance-order-service/guidebooking/add', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            if (resp.data.code === "success" || resp.data.code === "0") {
              this.searchGuideBooking();
              this.$message({
                message: '新增车贷成功',
                type: 'success'
              });
              this.addGuideBookingDialogVisible = false;
              this.resetForm('guideBookingForm');
            } else {
              this.$alert(resp.data.message || '', '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateGuideBooking(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/advance-order-service/guidebooking/update', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if (data.code === "success") {
              this.$message({
                message: '编辑车贷信息成功',
                type: 'success'
              });
              this.addGuideBookingDialogVisible = false;
              this.searchGuideBooking();
            } else {
              this.$alert('' + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {

          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteGuideBooking(userId) {
      this.$confirm('此操作将永久该车贷, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/advance-order-service/guidebooking/delete?userId=' + userId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "success") {
            this.addGuideBookingDialogVisible = false;
            this.$message({
              message: '删除车贷成功',
              type: 'success'
            });
            this.searchGuideBooking();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    statusSelectChange(val) {
      this.dialogStatusVal = val;
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchGuideBooking();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchGuideBooking();
    },
    submitGuideBookingForm(formName) {
      if ('add' == this.addFlag) {
        let reqParam = {
          name: this.guideBookingForm.name,
          telephone: this.guideBookingForm.telephone,
          salesmanId: this.guideBookingForm.salesmanId,
          channelId: this.editDialogChannelSelect,
          brandId: this.editDialogCarBrandSelect,
          carCategory: this.editDialogCarCategorySelect,
          whetherLoan: this.whetherLoanSelect,
          status: this.statusSelect,
          remark: this.guideBookingForm.remark,
        };
        this.addGuideBooking(formName, reqParam);
      }

      else if ('edit' == this.addFlag) {
        let reqParam = {
          guideBookingId: this.guideBookingForm.guideBookingId,
          name: this.guideBookingForm.name,
          telephone: this.guideBookingForm.telephone,
          salesmanId: this.guideBookingForm.salesmanId,
          channelId: this.editDialogChannelSelectVal,
          brandId: this.editDialogCarBrandSelectVal,
          carCategory: this.editDialogCarCategorySelectVal,
          whetherLoan: this.whetherLoanSelect,
          status: this.dialogStatusVal,
          remark: this.guideBookingForm.remark,
        };
        this.updateGuideBooking(formName, reqParam);
      }

      else if ('info' == this.addFlag) {
        console.log(this.guideBookingForm);
      }
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.whetherLoanSelect = 0;
        this.statusSelect = '';
        this.guideBookingForm = {};
        this.editDialogChannelSelect = '';
        this.editDialogChannelSelectVal = '';
        this.editDialogCarBrandSelect = '';
        this.editDialogCarBrandSelectVal = '';
        this.editDialogCarCategorySelect = '';
        this.editDialogCarCategorySelectVal = '';
        this.$refs[formName].resetFields();
      })
    },
    openDialogEvent(addFlag) {
    },
    openDialog(addFlag, data) {
      // 获取渠道、车品牌、车型下拉框项
      this.editDialogGetChannel();
      this.editDialogGetCarBrand();
      // this.editDialogGetCarCategory();

      if ('add' == addFlag) {
        this.addFlag = 'add';
        this.addGuideBookingDialogTitle = '新增';
      }

      else if ('edit' == addFlag) {
        this.addFlag = 'edit';
        this.addGuideBookingDialogTitle = '编辑';
        let tmp = {};
        Object.assign(tmp, data);
        this.guideBookingForm = tmp;

        // 绑定渠道
        this.editDialogChannelSelect = tmp.channel.channelName;
        this.editDialogChannelSelectVal = tmp.channelId;

        // 绑定品牌
        this.editDialogCarBrandSelect = tmp.carBrand.carBrandName;
        this.editDialogCarBrandSelectVal = tmp.brandId;

        // 绑定车型
        this.editDialogGetCarCategory(tmp.brandId)
        this.editDialogCarCategorySelect = tmp.carType.carCategoryName;
        this.editDialogCarCategorySelectVal = tmp.carType.carCategory;

        // 绑定状态
        if (data.status == 0) {
          this.statusSelect = '待受理';
        } else if (data.status == 1) {
          this.statusSelect = '已取消';
        } else if (data.status == 2) {
          this.statusSelect = '已受理';
        } else if (data.status == 3) {
          this.statusSelect = '已完成';
        }

        // 绑定贷款
        if (data.whetherLoan == 1) {
          this.whetherLoanSelect = 1;
        } else {
          this.whetherLoanSelect = 0;
        }
      }

      else if ('info' == addFlag) {
        console.log(data)
        this.addFlag = 'info';
        this.addGuideBookingDialogTitle = '';
        let tmp = {};
        Object.assign(tmp, data);
        this.guideBookingForm = tmp;

        // 绑定渠道
        this.editDialogChannelSelect = tmp.channel.channelName;
        this.editDialogChannelSelectVal = tmp.channelId;

        // 绑定品牌
        this.editDialogCarBrandSelect = tmp.carBrand.carBrandName;
        this.editDialogCarBrandSelectVal = tmp.brandId;

        // 绑定车型
        this.editDialogCarCategorySelect = tmp.carType.carCategoryName;
        this.editDialogCarCategorySelectVal = tmp.carType.carCategory;

        // 绑定状态
        if (data.status == 0) {
          this.statusSelect = '待受理';
        } else if (data.status == 1) {
          this.statusSelect = '已取消';
        } else if (data.status == 2) {
          this.statusSelect = '已受理';
        } else if (data.status == 3) {
          this.statusSelect = '已完成';
        }

        // 绑定贷款
        if (data.whetherLoan == 1) {
          this.whetherLoanSelect = 1;
        } else {
          this.whetherLoanSelect = 0;
        }
      }
      this.addGuideBookingDialogVisible = true;
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  },
  watch: {
    createTime(newCeateTime, oldCeateTime) {
      if (null == newCeateTime || undefined == newCeateTime) {
        this.createTime = [];
      }
    }
  }
}
</script>

<style scoped>
.span_hide {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  height: 24px;
  display: block;
}

.span_hide:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/advance-order/guideBookingList.vue